import { NgModule } from '@angular/core';
import { CustomDomSharedStylesHost } from '../inline-styles-csp/shared_styles_host';
import { ɵSharedStylesHost } from '@angular/platform-browser';

@NgModule({
  providers: [
    { provide: 'cspMetaSelector', useValue: '[name=csp-nonce]' },
    { provide: ɵSharedStylesHost, useClass: CustomDomSharedStylesHost },
  ],
})
export class InlineStylesCSPModule {}